export const intersection = (array1, array2) => array1.some((element) => array2.includes(element));
